module.exports = __webpack_public_path__ + "img/ic-bell-active.38cdc610.svg";